import React from 'react'
import { Box } from '@gousto-internal/citrus-react'
import { EndlessVarietySection } from './components/EndlessVarietySection'
import { BrandEndorsementsSection } from './components/BrandEndorsementsSection/BrandEndorsementsSection'
import { Recipe } from '@library/menu-service'

export type LandingPageContentProps = {
  onSignupCTAClick: () => void
  recipes: Recipe[]
  signupCTA: string
}

export function LandingPageContent({
  onSignupCTAClick,
  recipes,
  signupCTA,
}: LandingPageContentProps) {
  return (
    <Box data-testid="landing-page-content">
      <EndlessVarietySection
        signupCTA={signupCTA}
        onCTAClick={onSignupCTAClick}
        recipes={recipes}
      />
      <BrandEndorsementsSection />
    </Box>
  )
}
